/**
 * Offline-first sync queue using localStorage.
 * Each queued item has: { id, kind: 'tree'|'measurement', payload, created_at }
 */
const KEY = 'mg_sync_queue';

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch { return []; }
}
function write(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event('mg-sync-changed'));
}

export const syncQueue = {
  list: read,
  count: () => read().length,
  enqueue(kind, payload) {
    const q = read();
    q.push({
      id: 'lq_' + Math.random().toString(36).slice(2, 10),
      kind, payload, created_at: new Date().toISOString(),
    });
    write(q);
  },
  remove(id) {
    write(read().filter((x) => x.id !== id));
  },
  clear() { write([]); },
};

export function subscribeSync(cb) {
  const handler = () => cb(read());
  window.addEventListener('mg-sync-changed', handler);
  window.addEventListener('online', handler);
  window.addEventListener('offline', handler);
  return () => {
    window.removeEventListener('mg-sync-changed', handler);
    window.removeEventListener('online', handler);
    window.removeEventListener('offline', handler);
  };
}
